import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Spinner } from "@/components/ui/spinner";

interface ConfirmUploadModalProps {
  open: boolean;
  onClose: () => void;
  fileName: string;
  isSaving: boolean;
  onConfirm: () => void;
}

export const ConfirmUploadModal = ({ open, onClose, fileName, isSaving, onConfirm }: ConfirmUploadModalProps) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Upload Spreadsheet</DialogTitle>
          <DialogDescription>
            Are you sure you want to upload <span className="font-medium">{fileName}</span>? This will update the
            allocations based on the spreadsheet data.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isSaving}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isSaving}>
            {isSaving ? (
              <>
                <Spinner className="h-4 w-4" />
                Uploading...
              </>
            ) : (
              "Confirm Upload"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
